var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
import { IdMap, IdentifiableMap, RArray, toPairs } from "../../collections";
import { makeImmutable, Quantity } from "../../core";
import { perRestaurant } from "../../di";
import { inject } from "tsyringe";
import { ExtraFeeTypes, Menu, } from "../Menu";
import { ModifierInstance, } from "./ModifierInstance";
import { ModifierItemInstance } from "./ModifierItemInstance";
let ModifierInstanceFactory = class ModifierInstanceFactory {
    constructor(menu, extraFeeTypes) {
        this.menu = menu;
        this.extraFeeTypes = extraFeeTypes;
        makeImmutable(this);
    }
    create(params) {
        const { modifierType, modifierSettings, items } = params;
        const itemInstances = new RArray([...items]).mapOptional(([modifierItemTypeId, quantity, packagingFeeId]) => {
            const modifierItemType = modifierType.itemTypes.find(modifierItemTypeId);
            return modifierItemType === null
                ? null
                : new ModifierItemInstance({
                    modifierType,
                    modifierItemType,
                    defaultQuantity: modifierSettings.defaultQuantity(modifierItemTypeId),
                    quantity,
                    modifierItemPackagingFeeId: packagingFeeId,
                });
        });
        const itemMap = IdentifiableMap.fromIterable("variantKey", itemInstances, {
            ignoreDuplicates: true,
        });
        return new ModifierInstance({
            modifierType,
            freeItems: modifierSettings.freeItems,
            items: itemMap,
        });
    }
    fromStorageData(params) {
        const modifierType = this.menu.modifierTypes.rawFind(params.modifierTypeId);
        if (modifierType === null) {
            return null;
        }
        const modifierSettings = params.modifierSettingsProvider(modifierType);
        const storedItems = toPairs(params.storageData.items).mapOptional(([storedKey, itemStorageData]) => {
            // Key format: "typeId:feeId" (new) or "typeId" (old, no packaging)
            const colonIndex = storedKey.lastIndexOf(":");
            const rawTypeId = colonIndex >= 0 ? storedKey.slice(0, colonIndex) : storedKey;
            const modifierItemTypeId = modifierType.itemTypeIds.rawFind(rawTypeId);
            if (modifierItemTypeId === null) {
                return null;
            }
            const packagingFeeId = this.resolvePackagingFeeId(itemStorageData.packagingFeeId, modifierType, modifierItemTypeId);
            if (packagingFeeId === null && itemStorageData.packagingFeeId != null) {
                return null;
            }
            return [
                modifierItemTypeId,
                Quantity.fromNumber(itemStorageData.quantity),
                packagingFeeId,
            ];
        });
        const storedTypeIds = new Set(storedItems.raw.map(([id]) => id.value));
        const zeroItems = modifierType.itemTypes.raw.entries
            .filtered(([id]) => !storedTypeIds.has(id.value))
            .map(([id]) => [id, Quantity.Zero, null]);
        const items = storedItems.concatenated(zeroItems);
        return this.create({
            modifierType,
            modifierSettings,
            items,
        });
    }
    resolvePackagingFeeId(storedFeeId, modifierType, modifierItemTypeId) {
        if (storedFeeId == null) {
            return null;
        }
        const feeType = this.extraFeeTypes.rawFind(storedFeeId);
        if (feeType === null ||
            !feeType.requirements.testModifier(modifierType.id, modifierItemTypeId)) {
            return null;
        }
        return feeType.id;
    }
    createWithDefaultItems({ modifierType, modifierSettings, }) {
        return this.create({
            modifierType,
            modifierSettings,
            items: modifierSettings.defaultItems.entries.map(([id, qty]) => [id, qty, null]),
        });
    }
};
ModifierInstanceFactory = __decorate([
    perRestaurant(),
    __param(1, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof Menu !== "undefined" && Menu) === "function" ? _a : Object, typeof (_b = typeof IdMap !== "undefined" && IdMap) === "function" ? _b : Object])
], ModifierInstanceFactory);
export { ModifierInstanceFactory };
